import * as React from 'react';
import {useEffect,
} from "react";

import PageWrapper from "../../../../common/atom/wrapper/page_wrapper";
import styled from "styled-components";
import {ConstBreakPoint, ConstCalc} from "../../../../../config/styles_const/styles_const";
import Breadcrumbs from "../../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../../common/organism/progress";
import { routeConfig} from "../../../../../config/language/ja-JP/presentation/route_text";
import {TBreadcrumbItem} from "../../../../type/common";

interface IProps {
    isLoading: boolean;
    blobURL: string;
    handleGenerateCustomerPDF: () => void;
    handleDestroyCustomerPDF: () => void;
}

const CustomerMypagePDFInfoComponent: React.FC<IProps> = (props) => {

    const {
        isLoading,
        blobURL,
        handleGenerateCustomerPDF,
        handleDestroyCustomerPDF,
    } = props;

    useEffect(() => {
        handleGenerateCustomerPDF()

            return () => {
                handleDestroyCustomerPDF()
            }

    },[])

    if (isLoading) { return <Progress canAnimation={false}/>}

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.customerRoot,
        routeConfig.customerMypage,
        routeConfig.customerPDF,
    ]

    return (
        <PageWrapper>
            <Breadcrumbs breadcrumbItems={breadcrumbItems} />
            <StyledEmbed type="application/pdf" src={blobURL} />
        </PageWrapper>
    )
};

export default CustomerMypagePDFInfoComponent;
// PageWrapperと同条件の高さ設定

const StyledEmbed = styled.embed`
    width: 100%;
    min-height: ${ConstCalc.PageWrapperMinHeightSp};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        min-height: ${ConstCalc.PageWrapperMinHeight};
    }
`


// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/pdf/customer_mypage_main_pdf.tsx